export const addProduct = product => ({
  type: "@add/PRODUCT",
  product
})

export const removeProduct = list => ({
  type: "@remove/PRODUCT",
  list
})